import { useEffect } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { APP_NAME } from '@scriptto/shared';
import { useAuth } from '../../hooks/useAuth';
import { useIsAdmin } from '../../hooks/useIsAdmin';

const adminNavItems = [
  { to: '/admin', label: 'Clienti', end: true },
];

export default function AdminLayout() {
  const { signOut } = useAuth();
  const isAdmin = useIsAdmin();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAdmin, navigate]);

  const handleLogout = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  if (!isAdmin) return null;

  return (
    <div className="flex min-h-screen flex-col md:flex-row">
      {/* Sidebar desktop / topbar mobile */}
      <aside className="shrink-0 border-b border-slate-200 bg-white md:w-64 md:border-b-0 md:border-r">
        <div className="flex h-14 items-center border-b border-slate-100 px-4 md:h-16 md:px-6">
          <span className="text-sm font-bold tracking-tight text-brand-600">{APP_NAME}</span>
          <span className="ml-2 rounded bg-slate-100 px-1.5 py-0.5 text-xs font-semibold text-slate-600">
            Admin
          </span>
        </div>
        <nav className="flex overflow-x-auto p-2 md:flex-col md:gap-1 md:p-4">
          {adminNavItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-lg px-3 py-2 text-sm font-medium transition ${
                  isActive
                    ? 'bg-brand-50 text-brand-700'
                    : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900'
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden md:block md:px-4 md:pb-4">
          <button
            onClick={handleLogout}
            className="w-full rounded-lg px-3 py-2 text-left text-sm font-medium text-slate-500 transition hover:bg-slate-50 hover:text-slate-900"
          >
            Esci
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 bg-slate-50 p-4 md:p-8">
        <Outlet />
      </main>
    </div>
  );
}
